export default __webpack_public_path__ + "static/media/refresh.0af003c8.png";